import type {ChannelToggle, SimpleSectionSettings} from '@api/notifications';
import {Switch} from '@ui/shadcn/switch';
import {ChannelToggleGroup} from './ChannelToggleGroup';

/** Простая секция отчётов или задач; enabled не перезаписывает выбор каналов. */
export const SimpleSectionRow = ({
  label,
  description,
  value,
  connected,
  onChange,
}: {
  label: string;
  description?: string;
  value: SimpleSectionSettings;
  connected: ChannelToggle;
  onChange: (value: SimpleSectionSettings) => void;
}) => (
  <div className='min-w-0 space-y-2.5 py-4'>
    <div className='flex items-center justify-between gap-3'>
      <div className='min-w-0'>
        <span className='text-sm font-medium'>{label}</span>
        {description && (
          <p className='mt-1 text-xs text-[var(--color-muted-foreground)]'>
            {description}
          </p>
        )}
      </div>
      <Switch
        checked={value.enabled}
        aria-label={`Уведомления: ${label}`}
        className='shrink-0'
        onCheckedChange={(enabled) => onChange({...value, enabled})}
      />
    </div>
    <ChannelToggleGroup
      label={label}
      value={value.channels}
      connected={connected}
      disabled={!value.enabled}
      onChange={(channels) => onChange({...value, channels})}
    />
  </div>
);
